import * as React from 'react'
import { Link }   from 'react-router-dom'

import muiAppBar  from '@material-ui/core/AppBar'
import IconButton from '@material-ui/core/IconButton'
import Toolbar    from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Menu       from '@material-ui/icons/Menu'
import styled     from 'styled-components'

import { mainAppBarTool } from '../../project-utils/common-styles'
import testingHooks       from '../../testing-hooks'
import LogoutTool         from './LogoutTool'
import ProfileTool        from './ProfileTool'
import {indraEnabled} from '../../theme'

 const Logo = styled.img`
   display: block;
   height: 38px;
   position: relative;
   bottom: 0px;
`

const Bar = styled(muiAppBar)`
  z-index: ${({ theme }) => theme.zIndex.drawer + 1};
  background-color: ${({ theme }) => theme.headerBarColor};
`

const Burger = styled(IconButton)`
  ${mainAppBarTool}
`

interface Props {
  onMenuClick: () => void
}

const AppBar = ({ onMenuClick }: Props) => (
  <Bar position="absolute">
    <Toolbar>
      <Burger
        data-test-id={testingHooks.buttons.burger}
        onClick={onMenuClick}
        color={'inherit'}
      >       
        <Menu />
      </Burger>
      <div style={{ flex: 1 }}>
        <span>
          <Link href={'/dashboard'} to={'/dashboard'}>
            <Typography variant={'title'} color={'inherit'}>
              
              {<Logo
               src={!indraEnabled ? '/assets/logo_white_updated.png' : '/assets/indra.png'}
               data-test-id={testingHooks.blc}
               />
               }
            </Typography>
          </Link>
        </span>
      </div>
      <ProfileTool />
      <LogoutTool />
    </Toolbar>
  </Bar>
)
export default AppBar



// WEBPACK FOOTER //
// ./src/components/molecules/AppBar.tsx